import axios from '@/utils'

// 领取预约
export function promoteCheckin (data) {
    return axios({
        method: 'post',
        url: '/promote/checkin',
        data
    })
}

// 持有碎片数量查询
export function pieceslist (params) {
    return axios({
        method: 'get',
        url: '/promote/pieceslist',
        params
    })
}

// 发起碎片交换
export function pieces_exchange (data) {
    return axios({
        method: 'post',
        url: '/promote/transfer/create',
        data
    })
}

// 自定义配置
export function config_data (params) {
    return axios({
        method: 'get',
        url: '/client/config_data',
        params
    })
}

// 用户回应碎片交换
export function transfer_reply (data) {
    return axios({
        method: 'post',
        url: '/promote/transfer/reply',
        data
    })
}


// 碎片活动分享二维码
export function qrcode (data) {
    return axios({
        method: 'post',
        url: '/promote/qrcode',
        data
    })
}

